<template>
    <img
        v-if="renderSrc"
        :src="renderSrc"
        :alt="alt"
        :style="imageStyle"
        @error="handleError"
        :v-lazy="isLazyLoad?renderSrc:''" />
    <svg v-else :style="{'background-color': placeholderColor }"/>
</template>
<script>
    /*默认的图片*/
    const defaultAvatorBg = require("@/assets/images/ucenter-default-avator.png");
    const defaultArticleBg = require("@/assets/images/default-article-bg.jpg");
    const isSupportObjectFit = () => document.documentElement.style.objectFit !== undefined;
    const ObjectFit = {
        NONE: 'none',
        CONTAIN: 'contain',
        COVER: 'cover',
        FILL: 'fill',
        SCALE_DOWN: 'scale-down'
    };

    export default {
        name: 'Images',
        props: {
            // 通过这个参数来判断在加载失败的时候加载哪一张默认图片
            imgType:String,
            src: String,
            alt: String,
            fit: String,
            lazyLoad:{
                type:Number,
                deafult:true
            },
            placeholderColor: {
                type: String,
                default: 'transparent'
            }
        },
        data(){
            return {
                isLazyLoad: true,
                renderSrc:this.src,
            }
        },

        computed: {
            imageStyle() {
                const { fit } = this;

                if (fit) {
                    return isSupportObjectFit()
                        ? { 'object-fit': fit }
                        : this.getImageStyle(fit);
                }

                return {};
            },
            getImageStyle(fit) {
                const { imageWidth, imageHeight } = this;
                const {
                    clientWidth: containerWidth,
                    clientHeight: containerHeight
                } = this.$el;

                if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) return {};

                const vertical = imageWidth / imageHeight < 1;

                if (fit === ObjectFit.SCALE_DOWN) {
                    const isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
                    fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
                }

                switch (fit) {
                case ObjectFit.NONE:
                    return { width: 'auto', height: 'auto' };
                case ObjectFit.CONTAIN:
                    return vertical ? { width: 'auto' } : { height: 'auto' };
                case ObjectFit.COVER:
                    return vertical ? { height: 'auto' } : { width: 'auto' };
                default:
                    return {};
                }
            }
        },
        watch: {
            'src':{
                handler(newVlaue,oldValue){
                    this.renderSrc=newVlaue
                    console.log(newVlaue,oldValue)
                }
            }
        },
        created(){
            this.isLazyLoad = this.lazyLoad === 0 ? false : true;
            console.log(this.src,'666')
        },
        methods:{
            handleError(){
                if(this.imgType === "avator"){
                    this.renderSrc = defaultAvatorBg;
                }else if(this.imgType === "article"){
                    this.renderSrc = defaultArticleBg;
                }
            }
        }
    }
</script>
